// extracted by mini-css-extract-plugin
export default {"container":"EditMerchantsProject_container__9vnxF","submit":"EditMerchantsProject_submit__BqmFC"};